import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SwitchLanguageRPC } from "./switchLanguageRPC";

export class SwitchLanguageRPCClientImpl extends SwitchLanguageRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SwitchLanguageRPC.Request): Promise<LeoRPCResult<SwitchLanguageRPC.Response, SwitchLanguageRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SwitchLanguage",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SwitchLanguageRPC.ResponseDTO,
      SwitchLanguageRPC.Errors.ErrorsDTO,
      SwitchLanguageRPC.Response,
      SwitchLanguageRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SwitchLanguage",
      SwitchLanguageRPC.Response.fromDTO,
      SwitchLanguageRPC.Errors.fromDTO
    );
  }
}
